import React from "react";

// Direction codes:
//  "up" | "down" | "left" | "right"
//  "up-right" | "up-left" | "down-right" | "down-left"
const ANGLES = {
  up: 0,
  "up-right": 45,
  right: 90,
  "down-right": 135,
  down: 180,
  "down-left": 225,
  left: 270,
  "up-left": 315,
};

/**
 * Solid black arrow, scales to fill the parent container while keeping
 * its aspect ratio. The container should give it explicit width / height.
 * Default points up; we rotate via CSS transform to draw the other 7
 * directions.
 */
export default function ArrowSvg({ direction = "up", className = "" }) {
  const angle = ANGLES[direction] ?? 0;
  return (
    <svg
      viewBox="0 0 100 100"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid meet"
      className={`vls-arrow ${className}`}
      style={{ transform: `rotate(${angle}deg)` }}
      data-testid={`arrow-${direction}`}
      aria-label={direction}
      role="img"
    >
      {/* Thick chevron-style arrow pointing UP */}
      <polygon
        points="50,4 96,50 72,50 72,96 28,96 28,50 4,50"
        fill="#000"
        stroke="#000"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
